import finding from './finding'
import routine from './routine'
import quickAction from './quickAction'
import improvementIdea from './improvementIdea'
import problemSolving from './problemSolving'

export default {
  finding,
  routine,
  quickAction,
  improvementIdea,
  problemSolving,
}
